/**
 * useIsOnScreenKeyboardOpen.js
 * 
 * This custom hook, `useIsOnScreenKeyboardOpen`, determines whether the on-screen keyboard 
 * is open on an iPad. It takes a ref to a text input element and returns a boolean 
 * indicating the keyboard status. The hook listens for `focus` and `blur` events 
 * on the input element to ascertain if the input is active (i.e., the keyboard is open).
 */

import { useState, useEffect } from 'react';
import { getUserData } from '../services/API';

function useIsOnScreenKeyboardOpen(inputRef) {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  const isIpad = () => {
    return getUserData().sessionData.isiPad;
  };

  useEffect(() => {
    const handleFocus = () => {
      if (isIpad()) {
        setIsKeyboardOpen(true);
      }
    };

    const handleBlur = () => {
      setIsKeyboardOpen(false);
    };

    const inputElement = inputRef.current;
    if (inputElement) {
      inputElement.addEventListener('focus', handleFocus);
      inputElement.addEventListener('blur', handleBlur);
    }

    return () => {
      if (inputElement) {
        inputElement.removeEventListener('focus', handleFocus);
        inputElement.removeEventListener('blur', handleBlur);
      }
    };
  }, [inputRef]);

  return isKeyboardOpen;
}

export default useIsOnScreenKeyboardOpen;
